export default function($) {

  // see to prevent text selection : https://css-tricks.com/block-links-the-search-for-a-perfect-solution/#method-4-sprinkle-javascript-on-the-second-method

  var card = $(".js-card");

  card.each(function() {
    $(this).on('click', function(e) {
      e.preventDefault();
      var isTextSelection = window.getSelection().toString();
      var link = $(this).find('.js-card-link').attr('href');

      if( typeof link !== "undefined" && !isTextSelection ) {
        window.location.href = link;
      }
    })
  })
}
